import React, { useState, useEffect } from 'react';
import { Collapse, Button } from '@material-ui/core';
import { RootState } from '../../models/RootState';
import { connect } from 'react-redux';
import { ButtonVariable } from '../../models/ButtonVariables';
import './ExchBetslip.scss';
import { enableOnclickBet, addOnclickBetAmount } from '../../store';
type StoreProps = {
  loggedIn: boolean;
  buttonVariables: ButtonVariable[];
  oneClickAmount: number;
  enableOnclickBet: (val: boolean) => void;
  addOnclickBetAmount: (amount: number) => void;
  isOneClickEnable: boolean;
};
const OneClieckBet: React.FC<StoreProps> = (props) => {
  const {
    buttonVariables,
    loggedIn,
    oneClickAmount,
    enableOnclickBet,
    addOnclickBetAmount,
    isOneClickEnable,
  } = props;
  const [successMsg, setSuccessMsg] = useState<string>(
    ''
  );
  const isenableOnclickBet = (data) => {
    if (oneClickAmount === 0 && data)
      addOnclickBetAmount(buttonVariables[0].stake);
      setSuccessMsg('1 click stake updated.');
    enableOnclickBet(data);
  };
  useEffect(() => {
    setTimeout(() => {
      setSuccessMsg('');
    }, 3000);
  }, [successMsg]);

  return (
    <>
      {' '}
      <div className="switch-ctn">
        <div className="text-switch">1 Click Betting</div>
        <Switch
          isOneClickEnable={isOneClickEnable}
          enableOnclickBet={(data) => isenableOnclickBet(data)}
        />{' '}
      </div>
      <Collapse
        in={isOneClickEnable}
        timeout="auto"
        unmountOnExit
        className="collapse-ctn"
      >
        <div className="quick-bet">
          {buttonVariables.map((bV, idx) => (
            <Button
              key={'qb-btn' + idx}
              className={
                bV.stake === oneClickAmount ? 'selected-qb-btn' : 'qb-btn'
              }
              onClick={() => {
                addOnclickBetAmount(bV.stake);
                setSuccessMsg('1 click stake updated.');
              }}
            >
              {bV.label}
            </Button>
          ))}
        </div>
        <div className="success-msg">
          {successMsg !== '' ? (
            <div className="err-section">
              <div className="success-box">
                <div className="msg">{successMsg && successMsg}</div>
              </div>
            </div>
          ) : null}
        </div>
      </Collapse>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    buttonVariables: state.exchBetslip.buttonVariables,
    oneClickAmount: state.exchBetslip.oneClickAmount,
    isOneClickEnable: state.exchBetslip.isOneClickEnable,
  };
};
const mapDispatchToProps = (dispatch: Function) => {
  return {
    addOnclickBetAmount: (amount: number) =>
      dispatch(addOnclickBetAmount(amount)),
    enableOnclickBet: (val: boolean) => dispatch(enableOnclickBet(val)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OneClieckBet);

const Switch = (props) => {
  const { isOneClickEnable, enableOnclickBet } = props;
  return (
    <div className="switch">
      <label className="switch__label">
        <input
          role="switch"
          type="checkbox"
          className="switch__input"
          checked={isOneClickEnable}
          onChange={(e) => enableOnclickBet(e.target.checked)}
        />
        <span className="switch__text" data-on="ON" data-off="OFF"></span>
        <span className="switch__handle"></span>
      </label>
    </div>
  );
};
